
import AppChatConversation from "@/components/chat/ChatConversation.vue";
import AppThreadModal from "@/components/chat/NewThreadModal.vue";
import { Conversation } from "@/models/chat/conversation";
import { ConversationGroup } from "@/models/chat/conversation-group";
import { ChatService } from "@/services/chat-service";

import { ChatState } from "@/utils/chat-state";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			msgInput: "",
			dragCount: 0,
			conversation: new Conversation(),
			conversationGroups: [] as ConversationGroup[],
			message: "",
			file: null as null | File,
			ready: false,
			lastDate: 0,
			showAddThreadModal: false
		};
	},
	props: {
		state: {
			type: Object as () => ChatState,
			required: true
		}
	},
	computed: {
		isDragging(): boolean {
			return this.dragCount > 0;
		}
	},
	watch: {
		"$route.params.userId"(to, from) {
			this.fetch();
		}
	},
	methods: {
		toggleNewThread() {
			this.showAddThreadModal = true;
		},
		async fetch() {
			this.conversation = await ChatService.getConversation(
				this.$route.params.userId
			);
			this.state.openedConversation = this.conversation;
			this.ready = true;
			await this.$nextTick();
		}
	},
	async created() {
		await this.fetch();
	},
	components: {
		AppThreadModal,
		AppChatConversation
	},
	i18nEx: {
		componentPrefix: "views.ChatDirectMessages"
	}
});
